import React from 'react';
import styled, { keyframes } from 'styled-components';

import { withTheme } from '../core/theming';

const animation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Spinner = styled.div`
	left: 99px;
	top: 5px;
	position: absolute;
	animation: ${animation} linear 1s infinite;
	background: ${(props) => props.theme.colors.brand500};
	width: 2px;
	height: 30px;
	border-radius: 60px;
	transform-origin: 1px 95px;
`;

const LoaderBlock = styled.div`
	width: 128px;
	height: 128px;
	position: relative;
	transform: translate(-64px, -64px) scale(0.64) translate(64px, 64px);

	& ${Spinner}:nth-child(1) {
		transform: rotate(0deg);
		animation-delay: -0.972222222222222s;
	}
	& ${Spinner}:nth-child(2) {
		transform: rotate(10deg);
		animation-delay: -0.944444444444444s;
	}
	& ${Spinner}:nth-child(3) {
		transform: rotate(20deg);
		animation-delay: -0.916666666666667s;
	}
	& ${Spinner}:nth-child(4) {
		transform: rotate(30deg);
		animation-delay: -0.888888888888889s;
	}
	& ${Spinner}:nth-child(5) {
		transform: rotate(40deg);
		animation-delay: -0.861111111111111s;
	}
	& ${Spinner}:nth-child(6) {
		transform: rotate(50deg);
		animation-delay: -0.833333333333333s;
	}
	& ${Spinner}:nth-child(7) {
		transform: rotate(60deg);
		animation-delay: -0.833333333333333s;
	}
	& ${Spinner}:nth-child(8) {
		transform: rotate(70deg);
		animation-delay: -0.777777777777778s;
	}
	& ${Spinner}:nth-child(9) {
		transform: rotate(80deg);
		animation-delay: -0.777777777777778s;
	}
	& ${Spinner}:nth-child(10) {
		transform: rotate(90deg);
		animation-delay: -0.75s;
	}
	& ${Spinner}:nth-child(11) {
		transform: rotate(100deg);
		animation-delay: -0.694444444444444s;
	}
	& ${Spinner}:nth-child(12) {
		transform: rotate(110deg);
		animation-delay: -0.666666666666667s;
	}
	& ${Spinner}:nth-child(13) {
		transform: rotate(120deg);
		animation-delay: -0.638888888888889s;
	}
	& ${Spinner}:nth-child(14) {
		transform: rotate(130deg);
		animation-delay: -0.611111111111111s;
	}
	& ${Spinner}:nth-child(15) {
		transform: rotate(140deg);
		animation-delay: -0.583333333333333s;
	}
	& ${Spinner}:nth-child(16) {
		transform: rotate(150deg);
		animation-delay: -0.555555555555556s;
	}
	& ${Spinner}:nth-child(17) {
		transform: rotate(160deg);
		animation-delay: -0.527777777777778s;
	}
	& ${Spinner}:nth-child(18) {
		transform: rotate(170deg);
		animation-delay: -0.5s;
	}
	& ${Spinner}:nth-child(19) {
		transform: rotate(180deg);
		animation-delay: -0.472222222222222s;
	}
	& ${Spinner}:nth-child(20) {
		transform: rotate(190deg);
		animation-delay: -0.444444444444444s;
	}
	& ${Spinner}:nth-child(21) {
		transform: rotate(200deg);
		animation-delay: -0.416666666666667s;
	}
	& ${Spinner}:nth-child(22) {
		transform: rotate(210deg);
		animation-delay: -0.388888888888889s;
	}
	& ${Spinner}:nth-child(23) {
		transform: rotate(220deg);
		animation-delay: -0.361111111111111s;
	}
	& ${Spinner}:nth-child(24) {
		transform: rotate(230deg);
		animation-delay: -0.333333333333333s;
	}
	& ${Spinner}:nth-child(25) {
		transform: rotate(240deg);
		animation-delay: -0.305555555555556s;
	}
	& ${Spinner}:nth-child(26) {
		transform: rotate(250deg);
		animation-delay: -0.277777777777778s;
	}
	& ${Spinner}:nth-child(27) {
		transform: rotate(260deg);
		animation-delay: -0.25s;
	}
	& ${Spinner}:nth-child(28) {
		transform: rotate(270deg);
		animation-delay: -0.222222222222222s;
	}
	& ${Spinner}:nth-child(29) {
		transform: rotate(280deg);
		animation-delay: -0.194444444444444s;
	}
	& ${Spinner}:nth-child(30) {
		transform: rotate(290deg);
		animation-delay: -0.166666666666667s;
	}
	& ${Spinner}:nth-child(31) {
		transform: rotate(300deg);
		animation-delay: -0.138888888888889s;
	}
	& ${Spinner}:nth-child(32) {
		transform: rotate(310deg);
		animation-delay: -0.111111111111111s;
	}
	& ${Spinner}:nth-child(33) {
		transform: rotate(320deg);
		animation-delay: -0.083333333333333s;
	}
	& ${Spinner}:nth-child(34) {
		transform: rotate(330deg);
		animation-delay: -0.055555555555556s;
	}
	& ${Spinner}:nth-child(35) {
		transform: rotate(340deg);
		animation-delay: -0.027777777777778s;
	}
	& ${Spinner}:nth-child(36) {
		transform: rotate(350deg);
		animation-delay: 0s;
	}
`;

const Loader = (props) => (
	<LoaderBlock>
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
		<Spinner {...props} />
	</LoaderBlock>
);

export default withTheme(Loader);
